import api from '../../../core/api/api';

export const facturacionMedicosAPI = {
  getMedicoByUsuario: async (usuario) => {
    const response = await api.get('/Medicos/GetByUserAsync', {
      params: { usuario }
    });
    return response.data;
  },

  getFacturacionMedicos: async (idMedico, fechaDesde, fechaHasta) => {
    const response = await api.get('/Billing/GetShiftBillingMedical', {
      params: { idMedico, from: fechaDesde, to: fechaHasta }
    });
    return response.data;
  },

  getFacturacionCompletaMedicos: async (idMedico, mes, anio) => {
    const response = await api.get('/Billing/GetCompleteShiftBillingMedicals', { 
      params: { idMedico, mes, anio } 
    });
    return response.data;
  },

  getFacturacionDetalleMedicos: async (idMedico, fechaDesde, fechaHasta) => {
    const response = await api.get('/Billing/GetCompleteDetailShiftBillingMedical', {
      params: { idMedico, from: fechaDesde, to: fechaHasta, invoice: false }
    });
    return response.data;
  },

  getEstadoFacturacion: async (idMedico, fechaDesde, fechaHasta) => {
    const response = await api.get('/Billing/GetEstadoFacturacionMedico', {
      params: { idMedico, fechaDesde, fechaHasta }
    });
    return response.data;
  },

  uploadFactura: async (formData) => {
    const response = await api.post('/Billing/CargarFacturaMedicoAsync', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  uploadComprobante: async (formData) => {
    const response = await api.post('/Billing/CargarComprobantePagoMedicoAsync', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  getMedicos: async () => {
    const response = await api.get('/Medicos/ObtenerMedicos');
    return response.data;
  },

  getNotificaciones: async (envia, recibe, mes, anio) => {
    const response = await api.get('/Notifications/GetAsync', {
      params: { envia: envia || '', recibe: recibe || '', mes, anio }
    });
    return response.data;
  },

  createNotificacion: async (recibe, mes, anio, mensaje) => {
    const response = await api.post('/Notifications/CreateAsync', {
      recibe,
      mes,
      anio,
      mensaje
    });
    return response.data;
  },

  updateNotificacion: async (idNotificacion, lectura) => {
    const response = await api.put('/Notifications/UpdateAsync', {
      idNotificacion,
      lectura
    });
    return response.data;
  },

  iniciarCicloFacturacion: async (idMedico, mes, anio) => {
    const response = await api.post('/Billing/IniciarCicloFacturacionMedico', {
      idMedico,
      mes,
      anio
    });
    return response.data;
  },

  facturarTurno: async (idTurno, estaFacturado, idMedico) => {
    const response = await api.put('/Billing/FacturarTurnoMedico', {
      idTurno,
      estaFacturado,
      idMedico
    });
    return response.data;
  },

  facturarTurnosLote: async (idsTurnos, estaFacturado, idMedico) => {
    const response = await api.put('/Billing/FacturarTurnosMedicoLote', {
      idsTurnos,
      estaFacturado,
      idMedico
    });
    return response.data;
  },

  cambiarAuditoria: async (idTurno, auditoria, idMedico) => {
    const response = await api.put('/Billing/CambiarAuditoriaFacturacionMedico', {
      idTurno,
      auditoria,
      idMedico
    });
    return response.data;
  },

  eliminarFactura: async (idEstadoFacturacion) => {
    const response = await api.delete('/Billing/EliminarFacturaMedico', {
      params: { idEstadoFacturacion }
    });
    return response.data;
  },

  eliminarComprobante: async (idEstadoFacturacion) => {
    const response = await api.delete('/Billing/EliminarComprobanteMedico', {
      params: { idEstadoFacturacion }
    });
    return response.data;
  }
};
